import { Component, DoCheck, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TextSearchPattern } from '../../../../models/net/text-search-pattern';
import { AppService } from '../../../../services/app.service';
import { ResourceSearchRequest } from '../../../../models/net/request/resource-search-request';
import { EmbeddableTileComponent } from '../../../../interfaces/embeddable-tile-component';
import { SearchRequest } from '../../../../models/data/app-core/search-request';
import { SearchRequestService } from '../../../../services/search-requests/search-request.service';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { CreateResult } from '../../../../models/net/result/crud/create-result';
import { MessageSeverity } from '../../../../enums/message-severity';
import { UpdateResult } from '../../../../models/net/result/crud/update-result';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { AppMessage } from '../../../../interfaces/app-message';
import { DeleteResult } from '../../../../models/net/result/crud/delete-result';
import { SearchTileComponent } from '../../search-tile/search-tile.component';
import { MatButton } from '@angular/material/button';
import { ComponentDialogComponent } from '../../../component-dialog/component-dialog.component';

@Component({
    selector: 'app-resource-search-tile',
    templateUrl: './resource-search-tile.component.html',
    styleUrls: ['./resource-search-tile.component.css', '../../../../app.component.css']
})

export class ResourceSearchTileComponent extends SearchTileComponent { // implements OnInit, DoCheck, OnDestroy, EmbeddableTileComponent {

    public firstNameLabel: string = "First Name";
    public lastNameLabel: string = "Last Name";
    public firstNamePlaceholder: string = "(First Name)";
    public lastNamePlaceholder: string = "(Last Name)";

    public override setDataSource = (dataSource: SearchRequestEnvelope, componentDialogComponent: ComponentDialogComponent): void => {

        this.componentDialogComponent = componentDialogComponent;
        this.itemEnvelope = dataSource;
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        this.itemSearchRequest = JSON.parse(this.itemEnvelope.Document.Item.SearchRequestJson) as ResourceSearchRequest;
        this.itemSearchRequestSnapshot = this.appService.cloneObject(this.itemSearchRequest);

        super.saveButtonCaption = this.itemSearchRequest.IsAdvancedSearch ? "SAVE AS ADVANCED SEARCH" : "SAVE AS BASIC SEARCH";

        this.addAppFeedMessage(MessageSeverity.Info, "Save and / or run either basic or advanced search", true);

        this.saveButtonCaption = this.saveButtonCaption;

        this.componentDialogComponent.titleChanged.subscribe((title: string) => {

            this.itemEnvelope.Document.Item.Name = title;
        });

        this.componentDialogComponent.subTitleChanged.subscribe((subtitle: string) => {

            this.itemEnvelope.Document.Item.Description = subtitle;
        });
    }

    public override ngAfterViewInit(): void {

        const s: string = "";
    }
}
